<template>
  <div class="inline-flex items-center" :class="gapClass">
    <LanguageSwitcher :variant="variant" :compact="compact" />
    <template v-if="showTheme">
      <span
        aria-hidden="true"
        class="w-px h-5"
        :class="dividerClass"
      />
      <DarkModeToggle v-if="compact" :variant="variant" />
      <DarkModeTogglePill v-else :variant="variant" />
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: "dark",
    validator: (v) => ["dark", "light"].includes(v),
  },
  compact: {
    type: Boolean,
    default: false,
  },
  showTheme: {
    type: Boolean,
    default: true,
  },
});

const gapClass = computed(() => (props.compact ? "gap-3" : "gap-4"));

const dividerClass = computed(() =>
  props.variant === "dark"
    ? "bg-slate-700/60"
    : "bg-slate-300 dark:bg-slate-700"
);
</script>
